import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';




import { AppComponent } from './app.component';
import { SettingsService } from './.services/settings.service';
import { ConnectionService } from './.services/connection.service';
import { ChatService } from './.services/chat.service';

import { UsersListComponent } from './users-list/users-list.component';
import { RouterModule, Routes } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ChatComponent } from './chat/chat.component';
import { VideoComponent } from './video/video.component';
import { AudioOnlyComponent } from './audio-only/audio-only.component';
import { CreateJoinMenuComponent } from './ui/create-join-menu/create-join-menu.component';
import { UserControlsComponent } from './user-controls/user-controls.component';

import 'hammerjs';
import { FeedbackFormComponent } from './feedback-form/feedback-form.component';
import { RotatingAdComponent } from './rotating-ad/rotating-ad.component';
import { FooterComponent } from './footer/footer.component';
import { ScreenshareComponent } from './screenshare/screenshare.component';



const appRoutes: Routes = [
  {path: 'home', component: AppComponent},
  {path: 'about', component: ChatComponent}
];

@NgModule({
  declarations: [
    AppComponent,
    UsersListComponent,
    ChatComponent,
    VideoComponent,
    AudioOnlyComponent,
    CreateJoinMenuComponent,
    UserControlsComponent,
    FeedbackFormComponent,
    RotatingAdComponent,
    FooterComponent,
    ScreenshareComponent,

  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(appRoutes),
    FormsModule
  ],
  providers: [ConnectionService, SettingsService, ChatService],
  bootstrap: [AppComponent]
})
export class AppModule { }
